module.exports = __webpack_public_path__ + "img/tab-record.55ac7fcc.png";